import SGPlugins from "../../../../public_html/src/js/common/SGPlugins";
import AuthPlugin from './auth-plugin'
import ReCaptcha from './recaptcha'
import './scripts'

SGPlugins.register([
  AuthPlugin,
  ReCaptcha
])
SGPlugins.init()
